export const config = {
  // HOST_NAME:'http://localhost:8888/Ramesh/suv/restaurant/backEnd/ajax.php',
  // FILE_PATH:'http://localhost:8888/Ramesh/suv/restaurant/backEnd/uploads',
  // PAYMENT:'http://localhost:8888/stripe-custom/'
  HOST_NAME:'https://r1.ngazelabs.com/includes/ajax.php',
  FILE_PATH:'https://r1.ngazelabs.com/includes/uploads',
  PAYMENT:'https://r1.ngazelabs.com/includes/stripe-custom/'
};